module.exports = __webpack_public_path__ + "img/home1.478df342.png";